import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta, createRowActions } from "@msuite/ui/table";
import { formatNumber } from "@msuite/utils/numbers";
import {
	getArticleGroupNumberString,
	getArticleProductTypeNumberString,
} from "@msuite/utils/stock";
import type { ArticleProductTypeListItem } from "@msuite/utils/types";
import { NoteText } from "@/components/notes";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<ArticleProductTypeListItem>();

export const columns = [
	columnHelper.accessor(
		(row) => getArticleProductTypeNumberString(row.articleGroupNumber, row.number),
		{
			id: "number",
			header: localized("stock.order_no"),
			cell: (cell) => cell.getValue(),
		},
	),
	columnHelper.accessor((row) => getArticleGroupNumberString(row.articleGroupNumber), {
		id: "articleGroupNumber",
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("name", {
		id: "name",
		header: localized("general.name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("description", {
		id: "description",
		header: localized("general.description"),
		cell: (cell) => <NoteText note={cell.getValue()} />,
		size: 350,
	}),
	columnHelper.accessor("articleCount", {
		id: "articleCount",
		header: localized("stock.articles"),
		cell: (cell) => formatNumber(cell.getValue(), "integer"),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	createRowActions(RowActions),
];
